import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Container, Button, Form, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import OnboardingForm from '../components/OnboardingForm';

import LockboxFactory from "../contracts/LockboxFactory.json"
import Web3 from 'web3';

import lockboxLogo from '../assets/lockbox_horz_white_text.svg';
import "../styles/App.css";

function ConnectPage() {
  const [address, setAddress] = useState('To populate the address field, click "Set Address"');
  const [lockboxFactory, setLockboxFactory] = useState({});
  const [lockboxAddr2, setLockboxAddr2] = useState("");
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);

  // to track what phase on onboarding the app is on

  // phase1: front page with only "Get Started" button
  const [phase1, setPhase1] = useState(true);
  // phase2: second page displaying Onboarding Form
  const [phase2, setPhase2] = useState(false);

  const handleAccessLockbox = async (event) => {
    setLockboxAddr2(event.target.value);
  };

  const loadUserData = async () => {
    const web3 = window.web3;

    // find the network
    const networkId = await web3.eth.net.getId();

    // find the contract
    const deployedNetwork = LockboxFactory.networks[networkId];
    if (deployedNetwork) {
      const instance = new web3.eth.Contract(
        LockboxFactory.abi,
        deployedNetwork.address
      );

      setLockboxFactory(instance);
    } else {
      window.alert(
        "Lockbox factory contract not deployed to detected network."
      );
    }
  };

  const loadWeb3 = async () => {
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum);
      await window.ethereum.enable();
    } else if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider);
    } else {
      window.alert(
        "Non-Ethereum browser detected. You should consider trying MetaMask!"
      );
    }
  };

  const loadMetaMask = async () => {
    const web3 = window.web3;
    // find the metamask account
    let accounts = await web3.eth.getAccounts().then();
    setAddress(accounts[0]);
  };

  // function to switch phases
  const toPhase2 = async () => {
    setPhase1(false);
    setPhase2(true);
  }

  useEffect(() => {
    loadWeb3();
    loadUserData();
  }, []);

  return (
    <div>
      <div className="connect">
        <Navbar bg="dark" variant="dark">
          <Container>
            <Navbar.Brand href="/">
              <img
                alt=""
                src={lockboxLogo}
                height="32"
                className="d-inline-block align-bottom"
              />
            </Navbar.Brand>
            <Nav className="justify-content-end">
              <Button variant="dark" onClick={loadMetaMask}>
                Set Address
              </Button>
            </Nav>
          </Container>
        </Navbar>
        <div className="text-center">
          <div
            className="sidebar-background"
            style={{ width: "40%", margin: "auto", marginTop: "4rem" }}
          >
            <h2>Create a new Lockbox</h2>
            {address == 'To populate the address field, click "Set Address"' ?
              <p>To get started, set your address.</p>
              :
              null
            }
            <p><b>Your address:</b> {address}</p>
            {phase1 ?
              <Button variant="dark" onClick={toPhase2} disabled={address == 'To populate the address field, click "Set Address"'}>Get Started</Button>
              : <OnboardingForm address={address} users={users} roles={roles} lockboxFactory={lockboxFactory} setUsers={setUsers} setRoles={setRoles} phase2={phase2}/>}
          </div>

          <div
            className="sidebar-background"
            style={{ width: "40%", margin: "auto", marginTop: "4rem" }}
          >
            <h2 className="heading">Connect to your Lockbox</h2>
            <br />
            <div className="text-center">
              <Form>
                <Form.Group as={Col} sm={5} style={{ margin: "0 auto" }}>
                  <Form.Control type="text" name="addr" placeholder="Lockbox Address" onChange={handleAccessLockbox} />
                </Form.Group>
                <br />
                <Button variant="dark" disabled={lockboxAddr2 == ""}>
                  <Link
                    id="launch-link"
                    to="/app"
                    state={{ lockboxAddr: lockboxAddr2 }}
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Launch App
                  </Link>
                </Button>
              </Form>
            </div>
          </div>
          <br />
          <br />
        </div>
      </div>
    </div>
  );
}


export default ConnectPage;
